export default function formatMessageContentAudioTranslation (text) {
    return {
        text
    }
}
